import { SearchInput, SearchInputProps } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const SearchBoxWrapper = styled.div`
max-width: 300px;
min-width: 225px;
`;

type SearchProps = Pick<SearchInputProps, "placeholder" | "value" | "onChange"> & {
  onSearchInputChange: (query: string) => void;
};

export const Search: React.FC<SearchProps> = ({
  onSearchInputChange,
  value,
  onChange,
  placeholder
}) => {
  const { t } = useTranslation();

  return (
    <SearchBoxWrapper>
      <SearchInput
        onSearchInputChange={(searchQuery: string) => {
          onSearchInputChange(searchQuery);
        }}
        placeholder={placeholder || t("search.placeholder", {
          ns: "melco-common",
        })}
        value={value}
        onChange={onChange}
      />
    </SearchBoxWrapper>
  );
};
